<template>
  <v-card>
    <!-- <v-card-title>User Login</v-card-title> -->
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>edit</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Edit Account Head</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%;">
      <v-form ref="editAccountHeadForm" v-model="valid" lazy-validation>
        <v-layout column>
          <v-flex xs12>
            <v-text-field
              outline
              label="Title *"
              required
              v-model="editItem.title"
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>
          
          <v-textarea v-model="editItem.notes" outline label="Note/Comments"></v-textarea>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn color="blue" @click="onCancelled">Cancel</v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="blue"
        @click="editItemDo"
        :disabled="!valid || actionButtonClicked"
        :loading="actionButtonClicked"
      >Update</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ["editItem"],
  data() {
    return {
      actionButtonClicked: false,
      valid: true
    };
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    validate() {
      if (this.$refs.editAccountHeadForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.editAccountHeadForm.reset();
    },
    resetValidation() {
      this.$refs.editAccountHeadForm.resetValidation();
    },
    clearForm() {
      this.newItem.title = "";
      this.newItem.notes = "";
    },
    editItemDo() {
      if (this.$refs.editAccountHeadForm.validate()) {
        this.actionButtonClicked = true;
        this.put("/account_heads", this.editItem).then(res => {
          if (res.data.success) {
            this.onCancelled();
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    }
  },
  mounted() {
  }
};
</script>